import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { LEVEL_CHOICE } from '../config/values';

const CheckListBatch = ({ levelChoice, onSelect }) => {
    /**
     * 레벨 일괄 선택 클릭
     */
    const onClickLevelChoice = (choice) => {
        onSelect(choice);
    };

    return (
        <section>
            <div className="hgroup">
                <h2 className="no-line title">학습 단계 선택</h2>
            </div>

            <div className="check-list-batch-notice" style={{ marginTop: 10 }}>
                <div className="notice-icon">
                    <img
                        src="https://s.wink.co.kr/pc/renewalV3/icons/exclamation_mark_grey.png"
                        alt="info"
                        width={20}
                        style={{ marginBottom: -3 }}
                    />
                </div>
                <div>
                    <p className="notice-text">
                        지금 단계를 선택하셨더라도 실제 학습 중 선생님과의
                        상담을 통해 수준 재조정도 가능하오니 편하게 선택해
                        주세요.
                    </p>
                </div>
            </div>

            <div className="check-list-batch-container">
                <button
                    className={classNames(
                        'batch-select-box-button',
                        levelChoice === LEVEL_CHOICE.beginner
                            ? ' solid'
                            : ' outlined'
                    )}
                    onClick={() => {
                        onClickLevelChoice(LEVEL_CHOICE.beginner);
                    }}
                >
                    {'자녀의 연령에 맞는\n‘추천’단계로 선택'}
                </button>
                <button
                    className={classNames(
                        'batch-select-box-button',
                        levelChoice === LEVEL_CHOICE.manual
                            ? ' solid'
                            : ' outlined'
                    )}
                    onClick={() => {
                        onClickLevelChoice(LEVEL_CHOICE.manual);
                    }}
                >
                    {'자녀의 수준을 고려한\n학습단계로 ‘직접’ 선택'}
                </button>
            </div>
        </section>
    );
};

export default CheckListBatch;
